import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { WindowService } from '../window/window.service';

@Injectable()
export class AuthConfigService {
    config: any;

    constructor(configService: ConfigService,
                windowService: WindowService) {
        // The current page's origin (e.g. e.g. http://localhost:4200).
        const origin = windowService.window.location.origin;
        const apiEndpointValue = configService.config.apiEndpoint;
        const validAudienceValue = configService.config.validAudience;

        // Maps the api endpoint (e.g. http://localhost:54321) to it's corresponding
        // valid audience (e.g. https://jjrichards.onmicrosoft.com/a8c63de6-31b8-4440-9cfe-157cac3abc08).
        // The valid audience is:
        // a) Defined in the manifest of the 'Video Portal API' App Registration (under "identifierUris"), and
        // b) Configured in the back-end API.
        // Basically the "identifierUris" is what allows the web app to identify itself to the API.
        const endpoints = {};
        if (apiEndpointValue && validAudienceValue) {
            endpoints[apiEndpointValue] = validAudienceValue;
        }

        this.config = {
            cacheLocation: 'localStorage',
            clientId: configService.config.clientId,
            endpoints: endpoints,
            apiEndpoint: apiEndpointValue,
            extraQueryParameter: 'nux=1',
            navigateToLoginRequestUrl: false,
            postLogoutRedirectUri: origin + '/',
            redirectUri: origin + '/callback',
            tenant: configService.config.tenant,
            resource: configService.config.resource,
            authority: configService.config.authority
        };
    }
}
